import { useState } from 'react'
import { Card, Box, Typography, List } from '@mui/material'
import {
  TitleWrapper,
  Content,
  ContentItems,
  TenantItem,
  OddTenant,
  SelectedTenant,
  Footer,
  SecondaryButtonWrapper,
} from './SwitchTenantCard.styles'
import { SwitchTenantCardProps } from './SwitchTenantCard.types'
import { Button } from './Button'

export const SwitchTenantCard = ({
  title,
  tenantList,
  initialTenantId = '',
  primaryButtonLabel,
  secondaryButtonLabel,
  showSecondaryButton = true,
  handlePrimaryButtonClick,
  handleSecondaryButtonClick,
}: SwitchTenantCardProps) => {
  const [selectedTenantId, setSelectedTenantId] =
    useState<string>(initialTenantId)

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLElement>,
    tenantId: string
  ) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      setSelectedTenantId(tenantId)
    }
  }

  const shouldDisableButton = () => {
    return !selectedTenantId || selectedTenantId === initialTenantId
  }

  return (
    <Card>
      <TitleWrapper>
        <Typography variant="h2" color="primary">
          {title}
        </Typography>
      </TitleWrapper>

      <Content>
        <ContentItems component="nav" aria-label="list of tenants">
          {tenantList.map((tenant, index) => {
            const isSelected = tenant.id === selectedTenantId
            const isOdd = index % 2 !== 0

            const TenantComponent = isSelected
              ? SelectedTenant
              : isOdd
              ? OddTenant
              : TenantItem

            return (
              <TenantComponent
                tabIndex={0}
                key={tenant.id}
                onClick={() => setSelectedTenantId(tenant.id)}
                onKeyDown={(e) => handleKeyDown(e, tenant.id)}
                role="button"
                aria-label={tenant.name}
              >
                <Typography variant="body1">{tenant.name}</Typography>
              </TenantComponent>
            )
          })}
        </ContentItems>
      </Content>

      <Footer>
        <Box visibility={showSecondaryButton ? 'visible' : 'hidden'}>
          <SecondaryButtonWrapper>
            <Button
              variant="outlined"
              onClick={() => handleSecondaryButtonClick()}
            >
              {secondaryButtonLabel}
            </Button>
          </SecondaryButtonWrapper>
        </Box>
        <Button
          variant="contained"
          disabled={shouldDisableButton()}
          onClick={() => handlePrimaryButtonClick(selectedTenantId)}
        >
          {primaryButtonLabel}
        </Button>
      </Footer>
    </Card>
  )
}
